import styled from 'styled-components';

export const ConnectAccountInformationWrapper = styled.div`
  width: 100%;
  margin-top: 15px;
`;
